import type { Language } from '../i18n';

/**
 * Short labels of the NIVIO mockup that the long-form translation keys do not cover
 * (sidebar, sign-in). Keeping them here leaves `i18n.tsx` untouched.
 */
type ShellCopy = {
  newChat: string;
  search: string;
  groups: { today: string; yesterday: string; week: string; older: string };
  continueWithMicrosoft: string;
  or: string;
  privateHint: string;
};

export const SHELL_COPY: Record<Language, ShellCopy> = {
  nl: {
    newChat: 'Nieuwe chat',
    search: 'Zoeken',
    groups: { today: 'Vandaag', yesterday: 'Gisteren', week: 'Vorige 7 dagen', older: 'Ouder' },
    continueWithMicrosoft: 'Doorgaan met Microsoft',
    or: 'of',
    privateHint: 'Je gesprekken blijven privé in je account.',
  },
  en: {
    newChat: 'New chat',
    search: 'Search',
    groups: { today: 'Today', yesterday: 'Yesterday', week: 'Previous 7 days', older: 'Older' },
    continueWithMicrosoft: 'Continue with Microsoft',
    or: 'or',
    privateHint: 'Your conversations stay private to your account.',
  },
  fr: {
    newChat: 'Nouvelle discussion',
    search: 'Rechercher',
    groups: {
      today: 'Aujourd’hui',
      yesterday: 'Hier',
      week: '7 derniers jours',
      older: 'Plus ancien',
    },
    continueWithMicrosoft: 'Continuer avec Microsoft',
    or: 'ou',
    privateHint: 'Vos conversations restent privées sur votre compte.',
  },
};
